import React from 'react';
import styled, { css } from 'styled-components';

import { ContentContainer } from '@/modules/B2bHome/common.styles';
import { useB2bHomeData } from '@/modules/B2bHome/hooks';
import { ServiceFormSecondary } from '@/components/LandingWidgets';
import { media } from '@/utils/mixin';
import { ServiceFormSecondaryFields } from '@/components/LandingWidgets/components/ServiceFormSecondary/types';
import { submitB2bServiceForm } from '@/services/leads/leads-service';
import { googleEvent } from '@/utils/events';
import { getDealersOptions } from '@/utils/common';

function Form() {
  const {
    formTitle,
    formSubtitle,
    formImage,
    formMobileImage,
    formButtonTitle,
    formGoogleEvent,
    dealersRequests,
  } = useB2bHomeData();

  if (!formTitle || !formImage) {
    return null;
  }

  const sendServiceForm = async (
    values: ServiceFormSecondaryFields
  ): Promise<void> => {
    try {
      await submitB2bServiceForm({
        ...values,
        dealer: values.dealer?.value,
      }).then(() => {
        if (formGoogleEvent) {
          googleEvent(formGoogleEvent);
        }
      });
    } catch (error: any) {
      return Promise.reject(error);
    }
  };

  return (
    <Component id="form">
      <ContentContainer>
        <ServiceFormSecondary
          title={formTitle}
          subtitle={formSubtitle ?? ''}
          image={formImage}
          buttonTitle={formButtonTitle ?? ''}
          imageMobile={formMobileImage}
          fieldsConfig={{ dealers: getDealersOptions(dealersRequests) }}
          onSubmit={sendServiceForm}
        />
      </ContentContainer>
    </Component>
  );
}

export default Form;

const Component = styled.section`
  padding: 30px 0;

  ${media.tablet(css`
    padding: 20px 0;
  `)}
`;
